.current-time {
    font-size: 0.9rem;
    vertical-align: text-bottom;
    margin-right: 1ex;
}
